/** Standard medical qualifications for doctor profiles. */
export const MEDICAL_QUALIFICATIONS = [
  'MBBS',
  'MD',
  'DO',
  'MS',
  'DNB',
  'DM',
  'MCh',
  'BDS',
  'MDS',
  'PhD',
  'MD, MBBS',
  'MD, FACC',
  'MD, PhD',
  'MBBS, MD',
  'FRCS',
  'MRCP',
  'FACP',
] as const;

/** Union of known medical qualification strings. */
export type MedicalQualification = (typeof MEDICAL_QUALIFICATIONS)[number];
